import { DetailsStep } from '../DetailsStep/DetailsStep';
import { schema as detailsStepSchema } from '../DetailsStep/DetailsStep.schema';
import { DocumentStep } from '../DocumentStep/DocumentStep';
import { initialValues as documentStepInitialValues } from '../DocumentStep/DocumentStep.constants';
import { schema as documentStepSchema } from '../DocumentStep/DocumentStep.schema';
import { SelfieStep } from '../SelfieStep/SelfieStep';
import { initialValues as selfieStepInitialValues } from '../SelfieStep/SelfieStep.constants';
import { schema as selfieStepSchema } from '../SelfieStep/SelfieStep.schema';
import { Step } from './Wizard.types';

export const stepsByInitialStep = {
    [Step.Details]: [Step.Details, Step.Document, Step.Selfie],
    [Step.Document]: [Step.Document, Step.Selfie],
    [Step.Selfie]: [Step.Selfie],
};

export const wizardStepComponentsMap = {
    [Step.Details]: DetailsStep,
    [Step.Document]: DocumentStep,
    [Step.Selfie]: SelfieStep,
};

export const wizardStepSchemaMap = {
    [Step.Details]: detailsStepSchema,
    [Step.Document]: documentStepSchema,
    [Step.Selfie]: selfieStepSchema,
};

export const wizardInitialValues = {
    personDocuments: {
        ...documentStepInitialValues.personDocuments,
        ...selfieStepInitialValues.personDocuments,
    },
};
